import React, { useState, useEffect, useCallback } from 'react';
import { X, UserCircle } from 'lucide-react';
import FileUploader from '../../../../components/FileUploader';

const ModalFotoPerfil = ({ isOpen, onClose, formData, setFormData, onUpload }) => {
  const [loading, setLoading] = useState(false);

  // 1. Detectamos si hay un archivo nuevo en el formData
  // Verificamos si es una instancia de File (archivo crudo) y no un string (URL)
  const archivoEnFormData = formData?.fotoPerfil;
  const esArchivoNuevo = archivoEnFormData instanceof File || 
                         (Array.isArray(archivoEnFormData) && archivoEnFormData[0] instanceof File);

  // Cerrar con Escape
  const handleEsc = useCallback((event) => {
    if (event.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, handleEsc]);

  if (!isOpen || !formData) return null;

  const ejecutarSubida = async () => {
    // Extraemos el archivo real (manejando si FileUploader lo guarda como array o objeto único)
    const fileToUpload = Array.isArray(archivoEnFormData) ? archivoEnFormData[0] : archivoEnFormData;

    if (!fileToUpload || !(fileToUpload instanceof File)) {
      console.error("No hay un archivo válido para subir");
      return;
    }
    
    setLoading(true);
    try {
      await onUpload?.(fileToUpload);
      onClose();
    } catch (error) {
      console.error("Error al subir foto:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity" 
        onClick={onClose}
      />
      
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between bg-gray-50">
          <div className="flex items-center text-gray-800 font-bold">
            <UserCircle className="mr-2 w-5 h-5 text-blue-500" />
            Actualizar Foto de Perfil
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <X size={20} />
          </button>
        </div>

        <div className="p-6">
          <p className="text-sm text-gray-600 mb-6">
            Selecciona una foto profesional. El archivo debe ser JPG o PNG.
          </p>

          <FileUploader 
            formData={formData}
            setFormData={setFormData}
            fieldName="fotoPerfil"
            multiple={false}
            allowedTypes={['image/jpeg', 'image/png', 'image/jpg']}
            // Eliminamos el onFileSelect que no existe
          />
        </div>

        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 rounded-lg transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={ejecutarSubida}
            // El botón se habilita si detectamos que fotoPerfil ahora contiene un Archivo (File)
            disabled={!esArchivoNuevo || loading}
            className="px-6 py-2 bg-blue-600 text-white text-sm rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Subiendo...
              </>
            ) : 'Guardar Cambios'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalFotoPerfil;